import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { log } from '@hungryroot/o11y';
import { type CustomerAddress } from '@hungryroot/pages-checkout';
import { StatusCode, REACT_QUERY_KEYS } from '@hungryroot/rest';
import { getPossibleDays } from '@hungryroot/rest/api/get_possible_days/get';

const TIME_LIMIT_15_MINUTES = 15 * 60 * 1000;

export interface DateInfo {
  value: string;
  label: string;
}

export interface PossibleDays {
  selected_date: DateInfo;
  possible_dates: DateInfo[];
  temp_blackout_dates?: { [key: string]: string[] };
}

export function useGetPossibleDays(
  params: {
    orderId: number;
    customerId?: number;
    address: CustomerAddress;
    zipcode?: string;
  },
  options?: Pick<UseQueryOptions, 'enabled'>
) {
  const { orderId, customerId, address, zipcode } = params;

  return useQuery({
    queryKey: [REACT_QUERY_KEYS.ORDERS, 'order/:id/possible_days', zipcode],
    queryFn: async () => {
      const resp = await getPossibleDays(orderId);

      if (resp.status !== StatusCode.SuccessOK) {
        const path = `/api/get_possible_days/?order_id=${orderId}`;
        const data = {
          customerId,
          address,
          path,
          resp,
        };
        log('v1_get_possible_days', data);
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    gcTime: TIME_LIMIT_15_MINUTES,
    staleTime: TIME_LIMIT_15_MINUTES,
    retry: false,
  });
}
